// insights.ts — Patch 015.18 (Insights / Lessons).
//
// Backend: workers/core-os/src/routes/insights.ts (insights migration 0071).

import { request } from './request'

const pid = (id: string): string => encodeURIComponent(id)

export type InsightKind = 'pattern' | 'lesson'
export type InsightReviewState = 'unreviewed' | 'reviewed' | 'dismissed'

export interface InsightRow {
  id: string
  project_id: string
  kind: InsightKind
  title: string
  body_text: string
  body_format: string
  source_refs_json: string | null
  review_state: InsightReviewState
  generated_at: string | null
  prompt_version: string | null
  cost_estimate_usd: number | null
  created_at: string
  updated_at: string | null
}

export const insightsApi = {
  list: (projectId: string, kind?: InsightKind) =>
    request<{ ok: true; insights: InsightRow[]; count: number }>(
      `/api/projects/${pid(projectId)}/insights${kind ? `?kind=${kind}` : ''}`,
    ),
  generate: (projectId: string, kind: InsightKind) =>
    request<{
      ok: boolean
      kind?: InsightKind
      generated?: number
      error?: string
      detail?: string
    }>(`/api/projects/${pid(projectId)}/insights/generate`, {
      method: 'POST',
      body: JSON.stringify({ kind }),
    }),
  update: (
    projectId: string,
    id: string,
    body: { review_state?: InsightReviewState; archived?: boolean },
  ) =>
    request<{ ok: true; id: string; updated: string[] }>(
      `/api/projects/${pid(projectId)}/insights/${pid(id)}`,
      { method: 'PATCH', body: JSON.stringify(body) },
    ),
}
